import {Box, Button, Typography} from "@mui/material";
import React from "react";
import PermissionCheck from "./components/permissionCheck.tsx";
import {useNavigate} from "react-router";
import TicketList from "./components/TicketList/index.tsx";
import { useHasPolicy } from "@config/useHasPolicy.ts";
import { PolicyEnum } from "@config/policyEnum.ts";

const Ticket: React.FC = () => {
    const navigate = useNavigate();
     const showRaiseTicket = useHasPolicy(PolicyEnum.VIEW_RAISE_TICKET);
     const editRaiseTicket = useHasPolicy(PolicyEnum.EDIT_RAISE_TICKET);

    return (
        <Box className="px-4 md:px-8 pt-6" sx={{height: "calc(100vh - 120px)"}}>
            <PermissionCheck/>
            <Box className="flex pb-4 justify-between ">
                <Box className="hidden md:flex items-center">
                    <Typography className="pl-2">Tickets</Typography>
                </Box>
                {showRaiseTicket &&
                <Box className="w-full md:w-fit">
                    <Button
                        style={{
                            backgroundColor: "#318FE0",
                            color: "#fff",
                            textTransform: "none",
                            padding: "10px 18px",
                            fontSize: "1rem",
                            width: "100%",
                        }}
                        disabled={!editRaiseTicket}
                        onClick={() => navigate(`/chat/new`)}
                    >
                        Raise Ticket
                    </Button>
                </Box>
            }
            </Box>
            <TicketList/>
        </Box>
    );
};

export default Ticket;
